/* eslint-disable no-mixed-operators */
import Helper from "../../core/libraries/Helper";
import { checkFeatureAccess, FeberApiClient, feberApiGet } from "../../services/commonServices";
import { ILowerFirstCaseMetadata } from "./types";

export const Allow_Requestor_Manager_Fallback_Feature_Name = "AllowRequestorManagerFallback";
export interface IIsAccessibleResponse {
    isAccessible: boolean
    report: any
}

export const checkAccessibleReport = async (reportId: string) => {
    let response = await FeberApiClient.get("Report/IsAccessible", {
        params: {
            reportId: reportId
        }
    })
    return response.data.success && response.data;
}

export const checkAllowRequestorManagerFallback = async (): Promise<boolean> => {
    try {
        return await checkFeatureAccess(Allow_Requestor_Manager_Fallback_Feature_Name);
    } catch (error: any) {
        console.error("Failed to check Allow_Requestor_Manager_Fallback permission:", error);
        throw error;
    }
}

export const getReport = async (reportId: string) => {
    let response = await FeberApiClient.get("Report", {
        params: {
            reportId: reportId
        }
    })
    return response.data;
}

export const checkExistBlob = async (fileName: string) => {
    let response = await FeberApiClient.get("Report/BlobExists", {
        params: {
            fileName: fileName
        }
    })
    return !!response.data.success && response.data.data
}

export const updateReport = async (report: any) => {
    const ensureLowercaseObject = Helper.lowerCaseObjectValues({ ...report }, ["rou", "spfManager", "llDivisionAdmin"])
    let response = await (await FeberApiClient.put("Report"
        , ensureLowercaseObject,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )).data
    return !!response && !!response.success;
}


export const restartUpload = async (report: ILowerFirstCaseMetadata) => {
    // oneIDM often returns uppercase properties, we need to convert them to lowercas
    const ensureLowercaseObject = Helper.lowerCaseObjectValues({ ...report }, ["rou", "spfManager", "llDivisionAdmin"])
    let response = (await FeberApiClient.post("Upload/ReUpload", ensureLowercaseObject,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )).data
    return !!response.success
}

export const deleteReport = async (reportId: string) => {
    let response = (await FeberApiClient.delete("Report", {
        params: {
            reportId: reportId
        }
    })).data
    return !!response.success
}


export const initOrder = async (reportId: string) => {
    return await feberApiGet("Order/InitOrder", { reportId });
}


export const order = async (report: any) => {
    let response = await (await FeberApiClient.post("WorkOn/StartOrder"
        , { ...report }
        , {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })).data
    return !!response.success && response.message as string;
}

export const findReportId = async (reportGuid: string) => {
    let response = (await FeberApiClient.get("Report/FindReportId", {
        params: {
            guid: reportGuid
        }
    })).data
    return !!response && !!response.success && response.data
}